import { render, staticRenderFns } from "./SharedRooms.vue?vue&type=template&id=f9a908e2&"
import script from "./SharedRooms.vue?vue&type=script&lang=js&"
export * from "./SharedRooms.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports